/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["mat-sidenav[_ngcontent-%COMP%]{width:40%!important}.load-more[_ngcontent-%COMP%]{margin-top:16px}.content[_ngcontent-%COMP%]{margin:16px}.comments-title[_ngcontent-%COMP%]{margin-top:16px}.divider[_ngcontent-%COMP%]{margin-left:10px;margin-right:10px;margin-top:8px}"];
export { styles as styles };
